export default __webpack_public_path__ + "static/media/true_icon.734063d5.svg";